import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

// import Audio from '@/page/audio'//音頻
// import Video from '@/page/video'//視頻
// import Ebook from '@/page/eBook'//電子書

const Audio = () => import( /* webpackChunkName: "audio" */ '@/page/audio') //音頻
const Video = () => import( /* webpackChunkName: "video" */ '@/page/video') //視頻
const Ebook = () => import( /* webpackChunkName: "eBook" */ '@/page/eBook') //電子書
const Activity = () => import( /* webpackChunkName: "eBook" */ '@/page/activity/page/activity') //優惠券
// const Secrecy = () => import( /* webpackChunkName: "eBook" */ '@/page/secrecy') //隱私政策頁面

const NewAudio = () => import('@/page/newAudio')  //新H5音频
const NeweBook = () => import('@/page/neweBook')  //新H5电子书


const Home = () => import('@/page/home') //隱私政策頁面


const Pack = () => import('@/page/pack') //隱私政策頁面

const FreeTemp = () => import('@/page/freeTemp') //自由组版主页面

const Login = () => import('@/page/login') //自由组版登入界面

const Register = () => import('@/page/register')  //电邮注册界面

const Recharge = () => import('@/page/recharge') //支付页面

const Order = () =>  import('@/page/order') //我的页面查看支付

const BindEmail = () => import('@/page/bindEmail')  //第三方登入跳转绑定邮箱页面

const Forget = () => import('@/page/forget')  //忘记密码页面

/* const eBookTrial = () => import('@/page/eBookTrial')//電子書試閲 */

const PdfTrial = () => import('@/page/pdfTrial')//pdf試閲

const zhishuInfo = () => import('@/page/zhishuInfo')//新增静态页面

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/audio',
    name: 'audios',
    component: Audio,
  },
    {
      path: '/video',
      name: 'video',
      component: Video
    },
    {
      path: '/ebook',
      name: 'eBook',
      component: Ebook
    },
    /* {
      path: '/ebook-trial/:id/:probation',
      name: 'eBookTrial',
      component: eBookTrial,
      props: true,
    }, */
    {
      path: '/activity',
      name: 'Activity',
      component: Activity
    },
    {
      path: '/pack',
      name: 'Pack',
      component: Pack
    },
    {
      path: '/freeTemp',
      name: 'freeTemp',
      component: FreeTemp
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: Recharge
    },
    {
      path: '/order',
      name: 'order',
      component: Order
    },
    {
      path: '/bindEmail',
      name: 'bindEmail',
      component: BindEmail
    },
    // {
    //   path: '/newAudio/:mediaId',
    //   name: 'newAudio',
    //   component: NewAudio,
    // },
    {
      path: '/newAudio/:mediaId/:templateId',
      name: 'newAudio',
      component: NewAudio,
    },
    {
      path: '/neweBook/:mediaId/:templateId',
      name: 'neweBook',
      component: NeweBook
    },
    {
      path: '/forget',
      name: 'forget',
      component: Forget
    },
    {
      path: '/pdfTrial/:id',
      name: 'pdfTrial',
      component: PdfTrial
    },
    {
      path: '/zhishuInfo/:token/',
      name: 'zhishuInfo',
      component: zhishuInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js